/**
 * Determinmes the country from GeoIP
 *
 * Example:
 *
    export const getServerSideProps: GetServerSideProps<Props> = async function ({ req }) {
        return {
            props: {
                geoIpCountry: getGeoCountry(req),
            },
        };
    };
 */
// @ts-ignore
import cookieParser from 'cookie';
import { IncomingMessage, ServerResponse } from 'http';
import { NextApiRequest, NextApiResponse } from 'next';
import { ParsedUrlQuery } from 'querystring';
const GEO_IP_COUNTRY_ALLOWED = 'us';

export function getGeoCountry(req?: IncomingMessage) {
  const geoIpCountry = req?.headers['x-geo-country'];
  return typeof geoIpCountry === 'string' ? parseGeoIpCountry(geoIpCountry) : null;
}

// In nginx we send multiple geo ip countries separated by a comma
// this function determines the correct country
// e.g. *,*,GB_13,*,*
function parseGeoIpCountry(countryHeader: string) {
  const country = countryHeader.split(',').find((countryFromHeader) => countryFromHeader !== '*');

  if (!country) {
    return null;
  }

  // country will be of the format STRCODE_NUMCODE (e.g. GB_13)
  const countryStrCode = country.split('_')[0];

  if (!countryStrCode) {
    return null;
  }

  return countryStrCode.toLowerCase();
}

export function handleGeoMock(query: ParsedUrlQuery, req: IncomingMessage, res: ServerResponse) {
  let country = null;

  if ('geo-country' in query) {
    country = Array.isArray(query['geo-country']) ? query['geo-country'][0] : query['geo-country'];
    res.setHeader('Set-Cookie', `country=${country}; path=/; HttpOnly`);
  }

  const cookie = req.headers.cookie;
  const parsedCookie = cookie ? cookieParser.parse(cookie) : {};
  if (parsedCookie.country) {
    country = parsedCookie.country;
  }

  return country;
}

// Read country from nginx header, or force via GET or cookie parameter
export function getCountry(query: ParsedUrlQuery, req: NextApiRequest, res: NextApiResponse) {
  let country = getGeoCountry(req);
  const countryMock = handleGeoMock(query, req, res);
  if (countryMock) {
    country = countryMock;
  }

  return country;
}

export function isCountryAllowed(country: string) {
  return (country || '').toLowerCase().startsWith(GEO_IP_COUNTRY_ALLOWED);
}
